import * as types from './types';

const getExtraFeatures = postingId => {
  return {
    type: types.GET_FEATURES,
    meta: {
      async: true,
      blocking: false,
      api: 'publicadorProf',
      path: `/publication/api/v1/posting/STEP_EXTRA/${postingId}`,
      method: 'GET'
    }
  };
};

const updateFeatureCheckbox = (id, isChecked) => ({
  type: types.UPDATE_FEATURE_CHECKBOX,
  payload: { id, isChecked }
});

const updateFeatureSelect = (id, value) => ({
  type: types.UPDATE_FEATURE_SELECT,
  payload: { id, value }
});

const updateFeatureInput = (id, value) => ({
  type: types.UPDATE_FEATURE_INPUT,
  payload: { id, value }
});

const resetState = () => ({
  type: types.RESET_STATE
});

export { getExtraFeatures, updateFeatureCheckbox, updateFeatureSelect, updateFeatureInput, resetState };
